<!-- The Preview Addons Component -->
<!-- Description: Creating an addon section for the base modal component -->
<template>
    <div>
        <div v-for="addon in product.attributes.addons">
            <div style="background: #ebebeb;">
                <p class="margin-left title"
                   style="padding-top: 20px; padding-bottom: 20px; font-size: 16px; margin-top: 15px; margin-bottom: 15px;">
                    {{ addon.name }}
                </p>
            </div>
            <div class="margin-left" v-for="(option, index) in addon.options">
                <input type="checkbox" class="form-checkbox" :id="option.name + 'radio_' + index"
                       v-model="selected.addons[addon.name]" :value="option">
                <label :for="option.name + 'radio_' + index">
                    {{ option.name }} (+ {{ option.price_with_vat }} лв.)
                </label>
            </div>
        </div>
    </div>
</template>

<!-- TypeScript code -->
<script>
    export default {
        name: 'ThePreviewAddons',
        props: {
            product: {},
            selected: {},
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    input[type][disabled] { background-color: #f9f9f9; color: #ddd; cursor: default; }
    input[type][disabled] + label { color: #999; cursor: default; }
    .margin-left { margin-left: 15px; }
    label {
        font: 300 16px/1.7 'Open Sans', sans-serif;
        color: #666;
        cursor: pointer;
    }
</style>